import { useRouter } from "next/router";

import { EnsinioFooterBrandIcon } from "shared/providers/Layout/assets/icons/EnsinioFooterBrandIcon";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import { useTenantPlan } from "shared/utils/hooks/useTenantPlan";

import { EnsinioFooterBrandingContainer } from "./styles";

export const EnsinioFooterBranding = () => {
  const { pathname } = useRouter();
  const {
    state: { tenancy },
  } = useGlobalContext();
  const { isInFreePlan } = useTenantPlan();

  const isInAdminConsoleRoute = pathname?.includes("/console");
  const isInPaymentRoute = pathname?.includes("/payment");
  const isInControlPanelRoute = pathname?.includes("/cp");
  const isInGroupModerationRoute = pathname?.includes("/moderation");
  const isInUserProfileRoute = pathname?.includes("/foryou");

  const ensinioMarkIsEnabled =
    tenancy?.settings?.["advanced-theme"]?.themeEnsinioMark === "1";

  const shouldRender =
    (ensinioMarkIsEnabled &&
      !isInAdminConsoleRoute &&
      !isInPaymentRoute &&
      !isInGroupModerationRoute &&
      !isInControlPanelRoute &&
      !isInUserProfileRoute) ||
    isInFreePlan;

  if (!shouldRender) return null;
  return (
    <EnsinioFooterBrandingContainer>
      <EnsinioFooterBrandIcon />
      <div className="divider" />
      Crie sua própria plataforma <br /> e venda seus produtos online
    </EnsinioFooterBrandingContainer>
  );
};
